import { render, staticRenderFns } from "./PropertyCertificateProvider.vue?vue&type=template&id=fdcdf740"
import script from "./PropertyCertificateProvider.vue?vue&type=script&lang=js"
export * from "./PropertyCertificateProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports